import {Injectable} from '@angular/core';
import {HeaderService} from './header.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class BeaconService extends HeaderService {

    getBeaconsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getBeaconsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createBeacon(Beacon: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'beacon/',
            JSON.stringify({Beacon: Beacon}),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteBeacon(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'beacon/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateBeacon(Beacon: any, _id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'beacon/' + _id,
            JSON.stringify(Beacon),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getBeaconById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'beacon/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getAllBeaconsForSuperAdmin(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-all-beacons-for-super-admin/',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/beacon.service.ts